import {ErrorLogFunction} from '@/logging/ErrorLogFunction'
import {Environment, getEnvironment} from '@/services/infrastructure/envhelper.service'

const loggers:ErrorLogFunction[] = []

const registerLogger = (logFunc: ErrorLogFunction) => {
    loggers.push(logFunc)
}

const initializeLoggers = () => {
    if (getEnvironment() !== Environment.Local) {
        import('@/logging/TrackJSLogger').then((logger) => {
            registerLogger(logger.default)
        })
    }
    if (getEnvironment() === Environment.Local) {
        import('@/logging/ConsoleLogger').then((logger) => {
            registerLogger(logger.default)
        })
    }
}

initializeLoggers()